export const BRAND = {
  name: "La Contadina",
  tagline: "Pizzeria · Trattoria",
  since: "Seit 1998",
  family: "Familie Gagliardi",
  district: "Dresden-Löbtau",
  logo: "https://customer-assets.emergentagent.com/job_trattoria-home-1/artifacts/5db8q6ve_photostudio_1780129907255.png",
  phone: "0351 / 422 61 00",
  phoneHref: "tel:+493514226100",
  email: "info@lacontadina-dresden.de",
  facebook: "https://de-de.facebook.com/La-Contadina-Dresden-133834459965469/",
  address: "Reisewitzer Str. 49, 01159 Dresden",
  mapUrl: "https://goo.gl/maps/3ReYN5yMLUiFFc9t9",
  payment: "Kreditkartenzahlung ab 20 € möglich",
  transit: {
    bus: "Bus 63, 90 (Haltestelle Tharandtstr.)",
    tram: "Tram 6, 7, 12 (Haltestelle Tharandtstr.)",
  },
  seats: { inside: 85, terrace: 110 },
  hours: [
    { day: "Montag", time: "Ruhetag", closed: true },
    { day: "Dienstag", time: "11:45 – 14:00 · 17:30 – 22:00" },
    { day: "Mittwoch", time: "11:45 – 14:00 · 17:30 – 22:00" },
    { day: "Donnerstag", time: "17:30 – 22:00" },
    { day: "Freitag", time: "11:45 – 14:00 · 17:30 – 22:00" },
    { day: "Samstag", time: "11:45 – 14:00 · 17:30 – 22:00" },
    { day: "Sonntag", time: "11:45 – 14:00 · 17:30 – 21:30" },
  ],
  hoursNote: "Warme Küche bis 21:30 Uhr",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14885437/pexels-photo-14885437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  aboutWine: "https://images.unsplash.com/photo-1707313835513-6f44e631ffc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcG91cmluZyUyMHdpbmUlMjByZXN0YXVyYW50fGVufDB8fHx8MTc4MjMzNzA1MHww&ixlib=rb-4.1.0&q=85",
  aboutPottery: "https://images.unsplash.com/photo-1771830939417-3a61437b82cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxhcnRpc2FuYWwlMjBwaXp6YSUyMHBhc3RhJTIwcnVzdGljJTIwcGxhdGV8ZW58MHx8fHwxNzgyMzM3MDUwfDA&ixlib=rb-4.1.0&q=85",
  terrace: "https://images.unsplash.com/photo-1534650075489-3baecec1e8b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwdGVycmFjZSUyMG91dGRvb3IlMjBkaW5pbmclMjBpdGFsaWFufGVufDB8fHx8MTc4MjM0MTk4M3ww&ixlib=rb-4.1.0&q=85",
  gnocchi: "https://images.unsplash.com/photo-1774828893338-50fd6c5f3062?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxhcnRpc2FuYWwlMjBwaXp6YSUyMHBhc3RhJTIwcnVzdGljJTIwcGxhdGV8ZW58MHx8fHwxNzgyMzM3MDUwfDA&ixlib=rb-4.1.0&q=85",
  linguine: "https://images.pexels.com/photos/12015214/pexels-photo-12015214.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  oliveBottle: "https://images.pexels.com/photos/14766731/pexels-photo-14766731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  oliveHarvest: "https://images.unsplash.com/photo-1753703986291-6f95a7f299ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwb2xpdmUlMjBvaWwlMjBib3R0bGUlMjBoYXJ2ZXN0fGVufDB8fHx8MTc4MjM0MTk4Mnww&ixlib=rb-4.1.0&q=85",
  gallery1: "https://images.pexels.com/photos/32738698/pexels-photo-32738698.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  gallery2: "https://images.unsplash.com/photo-1574966739987-65e38db0f7ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxmaW5lJTIwZGluaW5nJTIwaXRhbGlhbiUyMHJlc3RhdXJhbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODIzMzcwNTB8MA&ixlib=rb-4.1.0&q=85",
  gallery3: "https://images.pexels.com/photos/16018408/pexels-photo-16018408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallery4: "https://images.pexels.com/photos/6897388/pexels-photo-6897388.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const MENU = [
  {
    category: "Antipasti",
    items: [
      { name: "Burrata Pugliese", desc: "Cremige Burrata, Tomaten-Confit, Basilikum & Olivenöl", price: "14" },
      { name: "Tagliere del Contadino", desc: "Auswahl an Salumi und Käse, Honig und Senffrüchte", price: "18" },
      { name: "Vitello Tonnato", desc: "Kalbfleisch in Scheiben, Thunfischsauce, Kapern", price: "16" },
      { name: "Carciofi alla Romana", desc: "Geschmorte Artischocken, Minze, Knoblauch & Petersilie", price: "12" },
    ],
  },
  {
    category: "Pasta",
    items: [
      { name: "Tagliatelle al Ragù", desc: "Hausgemachte Eierpasta mit 6-Stunden-Ragù alla Bolognese", price: "16" },
      { name: "Cacio e Pepe", desc: "Tonnarelli, Pecorino Romano DOP, schwarzer Pfeffer", price: "15" },
      { name: "Gnocchi al Tartufo", desc: "Kartoffelgnocchi, schwarze Trüffelcreme, Parmigiano", price: "19" },
      { name: "Linguine alle Vongole", desc: "Venusmuscheln, Knoblauch, Weißwein & Petersilie", price: "21" },
    ],
  },
  {
    category: "Pizza",
    items: [
      { name: "Margherita D.O.C.", desc: "San Marzano, Fiordilatte, Basilikum, Olivenöl", price: "11" },
      { name: "La Contadina", desc: "Gemüse aus dem Garten, Büffelmozzarella, Pesto", price: "15" },
      { name: "Diavola", desc: "Scharfe Salami, Fiordilatte, San Marzano", price: "14" },
      { name: "Tartufo & Funghi", desc: "Steinpilze, Trüffelcreme, Grana-Späne", price: "18" },
    ],
  },
  {
    category: "Dolci",
    items: [
      { name: "Tiramisù della Nonna", desc: "Mascarpone, Löffelbiskuit, Espresso & Kakao", price: "9" },
      { name: "Panna Cotta ai Frutti", desc: "Vanille-Panna-Cotta, Coulis von Waldfrüchten", price: "8" },
      { name: "Cannoli Siciliani", desc: "Schafsricotta, Schokostückchen, Pistazien", price: "9" },
    ],
  },
];

export const MENU_HIGHLIGHTS = [
  { name: "Gnocchi al Tartufo", desc: "Zarte Kartoffelgnocchi in samtiger schwarzer Trüffelcreme – unser beliebtestes Gericht.", price: "19", img: IMAGES.gnocchi },
  { name: "Linguine alle Vongole", desc: "Frische Venusmuscheln, Knoblauch, Weißwein und Petersilie auf handgerollten Linguine.", price: "21", img: IMAGES.linguine },
];
